import { IconButton } from "waapi/waap-ui/components/IconButton/IconButton.js";
import { RefreshArrow01Linear } from "waapi/waap-ui/components/Iconsax/RefreshArrow01Linear.js";
import { SmallAskWaalaxyAccountProps } from "./types.js";

export const SmallAskWaalaxyAccount = ({ onClick }: SmallAskWaalaxyAccountProps): JSX.Element => {
    return <IconButton onClick={onClick} icon={RefreshArrow01Linear} color="primary" />;
};
